import _ from 'lodash'
import { UUID } from '@/plugins/common'

export default class Children {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      name: '',
      reportId: '',
      childrenReportId: '',
      childrenReportColumnId: '',
      referenceReportColumnId: '',
      type: ''
    }
    _.defaults(this, args, defaults)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/children.js